<script>
// `~/stores/episode-store` lives outside the dynamic-component-editor
// directory tree (forbidden by the editor's isolation rule). The
// canvas preview doesn't need to wire up real like/unlike actions —
// it just needs to render the example entity's like count. Drop the
// store import + handleClick body so the element renders inside
// Studio without leaving the editor boundary.
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";

export default {
  name: "EpisodeLikeCountAction",
  elementPanelSettings: {
    displayName: "Like Action",
    displayIcon: "solar:like-bold",
    elementGroup: "episode",
    elementType: "element",
  },
  extends: DynamicComponentActionElement,
  mixins: [EpisodePageElementMixin],
  computed: {
    myValue() {
      return this.getOptionValue(DisplayValue) === "hide" ? "" : this.entity?.likeCount ?? 0;
    },
  },
  methods: {
    handleClick() {
      // No-op in Studio. Real like/unlike round-trips to the episode
      // store live on the FanWeb side; the editor preview just shows
      // the example count.
    },
  },
};
</script>
